import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 6H12l-2-2H2v16h20V6zm-3 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
}), 'CreateNewFolderSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CreateNewFolderSharp.js
// module id = 2972
// module chunks = 2